export enum eTagType {
  NORMAL = 'normal',
  ESCALATION = 'escalation',
}
